import { IKitComponentInput } from "@/interfaces/kit.interface";

type UseKitDataReturn = Partial<IKitComponentInput> & {
  qty: number;
  title: string;
};

type UseKitDataProps = { kit: IKitComponentInput | null };

function useKitData({ kit }: UseKitDataProps): UseKitDataReturn {
  const qty = kit?.quantity || 0;

  const title = kit?.referenceSkuName || "";
  return {
    ...kit,
    title,
    qty,
  };
}

export default useKitData;
